export * from './lib/shared-models/shared-models';

// Modelos de navegación
export * from './lib/navigation/nav-menu.models';

// Autenticación y permisos
export * from './lib/models/auth.models';

// Paginación e historial (contratos HTTP compartidos)
export * from './lib/models/pageable.models';

// Re-export explícito del wrapper API (también vía auth.models)
export type { ApiResponse } from './lib/models/api-response';

// Modelos de operaciones
export * from './lib/models/operations.models';

// Estructura (empresas, sucursales, redes, etc.)
export * from './lib/models/structure.models';

// Horarios y geocodificación (formularios compartidos con ui-library)
export * from './lib/models/schedule.models';

// Modelos de cumplimiento y configuración
export * from './lib/models/compliance.models';
export * from './lib/models/settings.models';

// Modelos de tesorería
export * from './lib/models/treasury.models';

// Catálogos logísticos / preloaded
export * from './lib/models/catalogs.models';

// Reportes (metadatos de informes)
export * from './lib/models/reports.models';

// Modelos de soporte
export * from './lib/models/support.models';

// Utilidades de formularios / valores API
export * from './lib/utils/form-value.utils';

// Validación / helpers de upload de archivos
export * from './lib/utils/file-upload.utils';
export { formatFileSize } from './lib/utils/format-file-size.utils';
